__turbopack_context__.v({
  "active": "hwjJpa_active",
  "link": "hwjJpa_link",
});
